import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PCardTableSortabelButtonModel } from '../../models/pcard-table-sortable-button-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-pcard-table-sortabel-button',
  templateUrl: './pcard-table-sortabel-button.component.html',
  styleUrls: ['./pcard-table-sortabel-button.component.css']
})
export class PCardTableSortabelButtonComponent {

  constructor(private logger: LoggerService) {
  }

  @Input() sortOption!: PCardTableSortabelButtonModel;

  @Input() columnName!: string;

  @Output() sortingChange = new EventEmitter<PCardTableSortabelButtonModel>();

  private clearTimer: VoidFunction | undefined;

  public changeSort(column: string) {
    try {

      if (this.sortOption.sortColumn != column) {
        this.sortOption.sortColumn = column;
        this.sortOption.desc = false;
        this.hideFade();
        this.sortingChange.emit(this.sortOption);
        return;
      }

      if (!this.sortOption.desc) {
        this.sortOption.desc = true;
        this.hideFade();
        this.sortingChange.emit(this.sortOption);
        return;
      }

      this.sortOption.desc = false;
      this.sortOption.sortColumn = '';
      this.hideFade();
      this.sortingChange.emit(this.sortOption);

    } catch (error) {
      this.logger.addException(error, true);
    }
  }

  public endTimer() {

    this.clearTimer?.();

    var fields = document.getElementsByClassName('sort-animate');
    for (let index = 0; index < fields.length; index++) {
      const element = fields[index];

      element.classList.remove('animate__fadeIn');
      element.classList.remove('animate__fadeInDown');
      element.classList.remove('animate__fadeInUp');
    }

  }

  public hideFade() {

    const deadInterval = setInterval(() => {
      this.endTimer();
    }, 1000);

    this.clearTimer = () => clearInterval(deadInterval);
  }

}
